const payoutNetworks = {
    "Mpesa": "Mpesa",
    "Airtel": "Airtel",
    "Equitel": "Equitel",
    "MobileMoney": "Mobile Money",
    "CashPick": "Cash Pick",
    "BankAccount":"Bank Account"

}

export default  payoutNetworks;